import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Description, GridView } from "@mui/icons-material";
import { QuickStartCard } from "../components/QuickStartCard";

interface QuickStartSectionProps {
  onBlankSite: () => void;
  onChooseTemplate: () => void;
}

export const QuickStartSection: React.FC<QuickStartSectionProps> = ({ onBlankSite, onChooseTemplate }) => {
  return (
    <Stack spacing={2.5} sx={{ marginBottom: 5 }}>
      {/* Section Header */}
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "0.08em",
            color: "var(--fx-surface-texttertiary, #94A3B8)",
            textTransform: "uppercase",
          }}
        >
          Quick Start
        </Typography>
      </Box>

      {/* Cards Grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
        }}
      >
        {/* <QuickStartCard
          icon={<Description />}
          title="Blank site"
          subtitle="Start from scratch"
          onClick={onBlankSite}
        /> */}
        <QuickStartCard icon={<GridView />} title="Choose a template" subtitle="Pre-built high converting blocks" onClick={onChooseTemplate} />
      </Box>
    </Stack>
  );
};
